import { REQUEST_TYPES, CREATE_REQUEST_STATUS } from '@demandproai/shared';
import { useAddCaseFormContext } from '../contexts/AddCaseFormContext';

/**
 * Derives the current Silent Witness request failure state from case context.
 * @returns {{ hasFailed: boolean, errorMessage: string | undefined }}
 */
const useSilentWitnessStatus = () => {
  const { createRequests } = useAddCaseFormContext();
  const latestRequest = createRequests?.[REQUEST_TYPES.SILENT_WITNESS];
  const hasFailed = latestRequest?.status === CREATE_REQUEST_STATUS.FAILED;
  const errorMessage = latestRequest?.errorMessage;
  return { hasFailed, errorMessage };
};

export default useSilentWitnessStatus;
